<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/c6KMwt/tc-custom/9781399075572.jpg?1728725936432" alt="This image is the cover for the book Fall of Roman Britain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fall of Roman Britain
      </h1>
      <p class="bookDescription body article font2">
        <b>“Fascinating. . . . Will have a very special appeal to readers [interested] in the evolution of the English language, Roman history, and medieval British history.” —<i>Midwest Book Review</i></b><br/><br/>The end of empire in Britain was both more abrupt and more complete than in any of the other European Roman provinces. When the fog clears and Britain re-enters the historical record, it is, unlike other former European provinces of the Western Empire, dominated by a new culture that speaks a language that is neither Roman nor indigenous British Brythonic, and with a pagan religion that owes nothing to Romanitas or native British practices. <br/><br/>Other ex-Roman provinces of the Western Empire in Europe showed two consistent features conspicuously absent from the lowlands of Britain: the dominant language was derived from the local Vulgar Latin and the dominant religion was a Christianity that looked toward Rome. This leads naturally to the question: What was different about Britannia? A further anomaly in our understanding lies in the significant dating mismatch between historical and archaeological data of the Germanic migrations, and the latest genetic evidence. The answer to England’s unique early history may lie in resolving this paradox. In this book, John Lambshead summarizes the latest data gathered by historians, archaeologists, climatologists, and biologists—and synthesizes it into a fresh new explanation.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Lambshead, Simon Elliott
      </h2>
      
      <p class="authorDescription body article">Dr John Lambshead designed the award-winning computer game, Frederick Forsythe's Fourth Protocol, which was the first icon-driven game, was editor of Games & Puzzles and Wargames News, and has written a number of wargaming rules supplements for Games Workshop. He also wrote the officially licensed Dr Who gaming rules for Warlord Games. He was co-author, with Rick Priestley, of Tabletop Wargames, A Designer and Writers Handbook (Pen & Sword Books, 2016). When not designing games he is a novelist writing SF&F for Bane Books. He lives in Rainham, Kent.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen & Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67ac2546